import React, { useCallback } from 'react';
import styles from './court.module.css'
import CustomTooltip from '../../../shared/Tooltip/Tooltip';
import { DEFAULT_H, getZoneCatByZoneArea, zoneDataByZoneCat } from './court.data';
import { TextPathSvgs, ZoneSvgs, StaticFieldElements, CourtGrassBase } from './OuterCourt.data';
import { useSelector } from 'react-redux';

const CourtSvg1 = ({ showHoveredTooltip, makeSelectable, showZoneOnMobileScreen, _selectedZone, isLiveGame, teamDetails, hideHover }) => {    
    const { currentSeason } = useSelector(state => state.seasons);

    // tooltip props
    const tooltipProps = useCallback((zoneCat, addOffset) => {
        let zone = getZoneCatByZoneArea(zoneCat);        
        let zoneData = zoneDataByZoneCat(zone, currentSeason?.zoneCategories);

        return {
            title: showHoveredTooltip ? `Zone ${zoneCat} ( $${zoneData?.seasonPricePerToken} )` : ``,
            placement: "top",
            arrow: true,
            PopperProps: {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: addOffset ? addOffset : [0, -80],
                        },
                    },
                ],
            },
        };
    }, [showHoveredTooltip]);

    return (
    <g style={{ pointerEvents: hideHover ? 'none' : '' }}>
        {/* LAYER 1: The Grass Base (Bottom) */}
        <CourtGrassBase />

        {/* LAYER 2: The Interactive Hover Zones (Middle) */}
        {ZoneSvgs?.map((zone, key) => (
            <CustomTooltip {...tooltipProps(zone?.zoneNumber?.toString())} key={key}>                    
                <a className={`${styles["a"]} ${styles["court-area"]} ${showZoneOnMobileScreen ? styles.showZoneOnMobileScreen : ""} ${makeSelectable ? styles.makeSelectable : "" } ${styles.sideline} ${(makeSelectable && _selectedZone(zone?.zoneNumber?.toString())) ? isLiveGame ? styles["zone_active_live"] : styles["zone_active"] : ""} ${isLiveGame ? styles.liveGamePage : ""} ${(isLiveGame && _selectedZone(zone?.zoneNumber?.toString())) ? styles["zone_active_live"] : ""}`} href={`#${zone?.zoneName}`}>
                    {zone?.svg}
                </a>
            </CustomTooltip>
        ))}

        {/* LAYER 3: The Field Beauty Layer (Top) */}
        {/* This layer has pointer-events: none in its definition to allow clicks to pass through */}
        <StaticFieldElements />
        {TextPathSvgs?.map((path, key) => (
            <React.Fragment key={key}>{path?.svg}</React.Fragment>
        ))}

        {/* Home Team (Left Sideline - BIG) */}
        {(teamDetails && teamDetails?.length > 0) && (
            <foreignObject x="-280" y="100" width="250" height="350">
                <div className="flex flex-col items-center justify-center h-full">
                    <span style={{ fontSize: "24px", color: "rgba(255,255,255,0.8)", fontWeight: 600, letterSpacing: '2px' }}>HOME</span>
                    {teamDetails[0]?.teamImage && <img src={teamDetails[0]?.teamImage} alt="home" className="w-24 my-4" />}
                    <h1 style={{ fontSize: "32px", fontWeight: 900, color: "white", textTransform: 'uppercase', textAlign: 'center', lineHeight: 1.1 }}>{teamDetails[0]?.teamName}</h1>
                </div>
            </foreignObject>
        )}

        {/* Away Team (Right Sideline - BIG) */}
        {(teamDetails && teamDetails?.length > 0) && (
            <foreignObject x="1192" y="100" width="250" height="350">
                <div className="flex flex-col items-center justify-center h-full">
                    <span style={{ fontSize: "24px", color: "rgba(255,255,255,0.8)", fontWeight: 600, letterSpacing: '2px' }}>AWAY</span>
                    {teamDetails[1]?.teamImage && <img src={teamDetails[1]?.teamImage} alt="away" className="w-24 my-4" />}
                    <h1 style={{ fontSize: "32px", fontWeight: 900, color: "white", textTransform: 'uppercase', textAlign: 'center', lineHeight: 1.1 }}>{teamDetails[1]?.teamName}</h1>
                </div>
            </foreignObject>
        )}
    </g>
)


}

CourtSvg1.displayName = "CourtSvg1";

export default CourtSvg1